/* eslint-disable */

import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';

const commonEndPoint = 'api/V2/';
let merchantEmpID;
const latitude = localStorage.getItem('latitude');
const longitude = localStorage.getItem('longitude');
const handleApiRequest = async (method, endpoint, payload = null, customToken = null) => {
    const { lat, lng } = await getCurrentLocation(); // Fetch live lat/long
    try {
        const response =
            method === 'GET'
                ? await merchantCommonGetRequest(endpoint, payload, customToken, lat, lng) // Pass params for GET
                : await merchantCommonPost(endpoint, payload, customToken, lat, lng); // Pass body for POST

        return response;
    } catch (error) {
        console.error('API Error:', error);
        return null;
    }
};
export const merchantCommonPost = async (apiEndPoint, payload, customToken = null, lat, lng) => {
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }

    const endPoint = commonEndPoint + apiEndPoint;
    const token = customToken || localStorage.getItem('token');

    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': lat || '',
        'X-Longitude': lng || ''
    };

    try {
        const response = await axiosInstanceLive.post(endPoint, payload, { headers });
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};

export const merchantCommonGetRequest = async (apiEndPoint, params, customToken = null, lat, lng) => {
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }

    const endPoint = commonEndPoint + apiEndPoint;
    const token = customToken || localStorage.getItem('accessToken');

    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': lat || '',
        'X-Longitude': lng || ''
    };

    try {
        const response = await axiosInstanceLive.get(endPoint, {
            headers,
            params
        });
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};

const getCurrentLocation = () =>
    new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject('Geolocation is not supported by your browser');
        } else {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    resolve({ lat: latitude, lng: longitude });
                },
                (error) => {
                    reject('Please enable browser location access: ' + error.message);
                }
            );
        }
    });

export const POST_API_ENDPOINTS = {
    loginWithVerifyMpin: 'moneytransfer/loginWithVerifyMpin',
    forgotMpinOtp: 'moneytransfer/merchant/ForgotMpinOtp',
    forgotMpin: 'moneytransfer/merchant/ForgotMpin',
    refreshMpin: 'moneytransfer/merchant/refreshMpin',
    mpinExtension: 'moneytransfer/merchant/mpinExtension'
};

export const loginWithVerifyMpin = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.loginWithVerifyMpin, payload);
export const forgotMpinOtpApi = (payload, token) => handleApiRequest('POST', POST_API_ENDPOINTS.forgotMpinOtp, payload, token);
export const forgotMpinApi = (payload, token) => handleApiRequest('POST', POST_API_ENDPOINTS.forgotMpin, payload, token);
export const refreshMpinApi = (payload, token) => handleApiRequest('POST', POST_API_ENDPOINTS.refreshMpin, payload, token);
export const mpinExtensionApi = (payload, token) => handleApiRequest('POST', POST_API_ENDPOINTS.mpinExtension, payload, token);
